import { apolloClient } from "../../vue-apollo";
import { exQue } from "@/graphql/gql.js";
import {
  GET_NOTICIAS,
  GET_CUMPLEANIOS_DEL_DIA,
  GET_LAST_GALERIAS,
  GET_LAST_VIDEO,
  GET_NUEVOS_INGRESOS,
  GET_LAST_MOVIMIENTO,
  GET_LAST_RECONOCIMIENTO,
  // GET_LAST_POSTS_MURO,
  GET_PAGES_MURO,
  GET_MURO_BY_ID,
} from "../../graphql/queries";
import {
  EDITA_POST,
  CREAR_COMENTARIOS_MURO,
  EDITAR_COMENTARIOS_MURO,
  DAR_LIKE_COMENTARIO_MURO,
  QUITAR_LIKE_COMENTARIOS_MURO,
  ELIMINAR_POST,
  ELIMINAR_COMENTARIOS_POST,
  CREAR_POST_MURO,
  INSERT_VISTO_GENERAL,
} from "../../graphql/mutations";

export default {
  namespaced: true,
  state: {
    validationDisp: {},
    newSreen: {},
    listNoticias: [],
    listCumpleDay: [],
    lastGaleria: [],
    lastVideo: [],
    listaLastNewIngresos: [],
    listLastNewMovimientos: [],
    listLastReconociminetos: [],
    empresa: null,
    lastPostsMuro: [],
    lastPostsMuroPages: [],
    lastPostsMuroPage: 0,
    menuDestacados: [],
  },

  mutations: {
    INSERT_VISTO(state, response) {
      console.log(state.listNoticias, response);
      let noticiaVista = state.listNoticias.findIndex(
        (x) => x.id_noticia == parseInt(response.noticia)
      );
      if (noticiaVista > -1) {
        state.listNoticias[noticiaVista].confirm_visto++;
      }
      console.log(state.listNoticias[noticiaVista].confirm_visto);
    },
    SET_NOTICIAS(state, noticias) {
      state.listNoticias = noticias;
    },

    SET_CUMPLEAÑOS_DAY(state, cumpleanos) {
      state.listCumpleDay = cumpleanos;
    },

    SET_LAST_GALERIA(state, galerias) {
      state.lastGaleria = galerias;
    },

    SET_LAST_VIDEO(state, videos) {
      state.lastVideo = videos;
    },

    SET_LAST_NEW_INGRESOS(state, ingresos) {
      state.listaLastNewIngresos = ingresos;
    },
    SET_LAST_MOVIMIENTO(state, movimiento) {
      state.listLastNewMovimientos = movimiento;
    },
    SET_LAST_RECONOCIMIENTO(state, reconomientos) {
      state.listLastReconociminetos = reconomientos;
    },

    SET_LAST_POSTS_MURO(state, posteos) {
      state.lastPostsMuro = posteos;
    },

    SET_UPDATE_POST_MURO(state, post) {
      let muro_index = state.lastPostsMuro.findIndex(
        (muro) => muro.id_muro == post.id_muro
      );
      if (muro_index != undefined) {
        if (state.lastPostsMuro.length > 0)
          Object.assign(state.lastPostsMuro[muro_index], post);
      }
    },

    SET_COMENTARIO_MURO(state, comentario) {
      // console.log("SET_LIKE_COMENTARIO", comentario);
      let muro_index = state.lastPostsMuro.findIndex(
        (muro) => muro.id_muro == comentario.id_muro
      );
      state.lastPostsMuro[muro_index].comentarios;
      if (muro_index != undefined) {
        if (state.lastPostsMuro.length > 0) {
          state.lastPostsMuro[muro_index].comentarios = comentario.comentarios;
        }
        console.log(state.lastPostsMuro[muro_index].comentarios);
      }
    },
    DEL_COMENTARIO_MURO(state, comentario) {
      // console.log("DEL_LIKE_COMENTARIO", comentario);
      let found_index = state.lastPostsMuro.findIndex(
        (muro) => muro.id_muro == comentario.id_muro
      );
      if (found_index != undefined) {
        state.lastPostsMuro[found_index].comentarios = comentario.comentarios;
      }
    },

    SET_LIKE_MURO_POST(state, likeResult) {
      let postIdx = state.lastPostsMuro.findIndex(
        (post) => post.id_muro == likeResult.id_objeto
      );
      if (postIdx != undefined) {
        state.lastPostsMuro[postIdx].likes =
          state.lastPostsMuro[postIdx].likes ?? [];
        state.lastPostsMuro[postIdx].likes.unshift({
          id_like: likeResult.id_like,
        });
        state.lastPostsMuro[postIdx].confirm_like = [
          { id_like: likeResult.id_like },
        ];
        state.lastPostsMuro[postIdx].likes_global.push(likeResult);
        state.lastPostsMuro[postIdx].confirm_like_global = likeResult;
      }
    },
    REMOVE_LIKE_MURO_POST(state, likeResult) {
      let postIdx = state.lastPostsMuro.findIndex(
        (post) => post.id_muro == likeResult.id_objeto
      );
      console.log({ postIdx, post: state.lastPostsMuro[postIdx], likeResult });

      if (postIdx != undefined) {
        state.lastPostsMuro[postIdx].likes = state.lastPostsMuro[
          postIdx
        ].likes.filter((like) => like.id_like !== likeResult.id_like);
        state.lastPostsMuro[postIdx].confirm_like = [];
        const likeIndex = state.lastPostsMuro[postIdx].likes_global.findIndex(
          (like) => like.id_like == likeResult.id_like
        );
        state.lastPostsMuro[postIdx].likes_global.splice(likeIndex, 1);
        state.lastPostsMuro[postIdx].confirm_like_global = null;
      }
    },

    SET_NEW_POST(state, post) {
      // console.log("nuevo post,", post)
      console.log({ lastPostsMuro: state.lastPostsMuro, post });
      post.confirm_like = [];
      state.lastPostsMuro.unshift(post);
    },
    DEL_POST_MURO(state, post) {
      let found_index = state.lastPostsMuro.findIndex(
        (muro) => muro.id_muro == post.id_muro
      );
      if (found_index != undefined) {
        state.lastPostsMuro.splice(found_index, 1);
      }
    },
    SET_MENU_DESTACADO_HOME(state, destacados) {
      state.menuDestacados = destacados;
    },

    SET_LIKE_LAST_VIDEO(state, likeResult) {
      state.lastVideo.likes = state.lastVideo.likes ?? [];
      state.lastVideo.likes.unshift(likeResult);
      state.lastVideo.confirm_like = likeResult;
    },
    REMOVE_LIKE_LAST_VIDEO(state, likeResult) {
      state.lastVideo.likes = state.lastVideo.likes.filter(
        (like) => like.id_like !== likeResult.id_like
      );
      state.lastVideo.confirm_like = null;
    },
    SET_LIKE_LAST_GALLERY(state, likeResult) {
      const iImg = state.lastGaleria.imagenes.findIndex((i) => i.id_imagen == likeResult.id_subobjeto);
      state.lastGaleria.imagenes[iImg].likes = state.lastGaleria.imagenes[iImg].likes ?? [];
      state.lastGaleria.imagenes[iImg].likes.unshift(likeResult);
      state.lastGaleria.imagenes[iImg].confirm_like = likeResult;
    },
    REMOVE_LIKE_LAST_GALLERY(state, likeResult) {
      const iImg = state.lastGaleria.imagenes.findIndex((i) => i.id_imagen == likeResult.id_subobjeto);
      state.lastGaleria.imagenes[iImg].likes = state.lastGaleria.imagenes[iImg].likes.filter(
        (like) => like.id_like !== likeResult.id_like
      );
      state.lastGaleria.imagenes[iImg].confirm_like = null;
    },
    SET_STATE(state, { nameState, data }) {
      state[nameState] = data;
    },
  },

  actions: {
    async getNoticias({ commit }, data_) {
      commit("SET_NOTICIAS", []);
      return await exQue(GET_NOTICIAS, data_, true)
        .then((resp) => {
          commit("SET_NOTICIAS", resp);
          return resp;
        })
        .catch((err) => {
          console.log("Falla error, getNoticias ", err);
          return [];
        });
    },

    async getCumpleanosDay({ commit }, data_) {
      let response = [];
      let params = {
        query: GET_CUMPLEANIOS_DEL_DIA,
        variables: data_,
      };
      try {
        await apolloClient.query(params).then((res) => {
          if (!res.loading) response = res.data.birthdaysToday;
        });
      } catch (e) {
        console.log("Error metodo getCumpleanosDay", e);
      }
      return new Promise((resolve) => {
        if (response != null) {
          if (response.length == 0) {
            resolve(false);
          } else {
            resolve(response);
            commit("SET_CUMPLEAÑOS_DAY", response);
          }
        } else {
          resolve(false);
        }
      });
    },

    async getLastGalerias({ commit }, data_) {
      let params = {
        query: GET_LAST_GALERIAS,
        variables: data_,
        fetchPolicy: "network-only",
      };
      let response = null;
      try {
        const res = await apolloClient.query(params);
        if (!res.loading) response = res.data.LastGaleria;
        commit("SET_LAST_GALERIA", response);
      } catch (e) {
        console.log("Error metodo getLastGalerias", e);
      }
      return response;
    },

    async getLastVideo({ commit }, data_) {
      let params = {
        query: GET_LAST_VIDEO,
        variables: data_,
      };
      let response = null;
      try {
        const res = await apolloClient.query(params);
        if (!res.loading) response = res.data.videoUltimo;
        commit("SET_LAST_VIDEO", response);
      } catch (e) {
        console.log("Error metodo getLastVideo", e);
      }
      return response;
    },

    async addLikeLastGallery({ commit, dispatch }, payload) {
      Object.assign(payload, {
        id_modulo: "7",
      });
      const response = await dispatch("LikesModule/darLikeAction", payload, {
        root: true,
      });
      commit("SET_LIKE_LAST_GALLERY", Object.assign(response, payload));
      return response;
    },
    async delLikeLastGallery({ commit, dispatch }, payload) {
      Object.assign(payload, {
        id_modulo: "7",
       
      });
      const response = await dispatch("LikesModule/quitarLikeAction", payload, {
        root: true,
      });
      commit("REMOVE_LIKE_LAST_GALLERY", Object.assign(response, payload));
      return response;
    },

    async addLikeLastVideo({ commit, dispatch }, payload) {
      Object.assign(payload, {
        id_modulo: "6",
        id_subobjeto: "0",
      });
      const response = await dispatch("LikesModule/darLikeAction", payload, {
        root: true,
      });
      commit("SET_LIKE_LAST_VIDEO", Object.assign(response, payload));
      return response;
    },
    async delLikeLastVideo({ commit, dispatch }, payload) {
      Object.assign(payload, {
        id_modulo: "6",
        id_subobjeto: "0",
      });
      const response = await dispatch("LikesModule/quitarLikeAction", payload, {
        root: true,
      });
      commit("REMOVE_LIKE_LAST_VIDEO", Object.assign(response, payload));
      return response;
    },

    async getLastNewIngresos({ commit }, data_) {
      let response = null;
      let params = {
        query: GET_NUEVOS_INGRESOS,
        variables: data_,
      };
      try {
        await apolloClient.query(params).then((res) => {
          if (!res.loading) response = res.data.LastNewIngresos;
        });
      } catch (e) {
        console.log("Error metodo getLastNewIngresos", e);
      }
      return new Promise((resolve) => {
        if (response != null) {
          if (response.length == 0) {
            resolve(false);
          } else {
            resolve(response);
            commit("SET_LAST_NEW_INGRESOS", response);
          }
        } else {
          resolve(false);
        }
      });
    },

    async getLastMovimientos({ commit }, data_) {
      let response = [];
      let params = {
        query: GET_LAST_MOVIMIENTO,
        variables: data_,
      };
      try {
        await apolloClient.query(params).then((res) => {
          if (!res.loading) response = res.data.LastNewMovimientos;
        });
      } catch (e) {
        console.log("Error metodo LastNewMovimientos", e);
      }
      return new Promise((resolve) => {
        if (response != null) {
          if (response.length == 0) {
            resolve(false);
          } else {
            resolve(response);
            commit("SET_LAST_MOVIMIENTO", response);
          }
        } else {
          resolve(false);
        }
      });
    },

    async getLastReconocimiento({ commit }, data_) {
      let response = null;
      let params = {
        query: GET_LAST_RECONOCIMIENTO,
        variables: data_,
      };
      try {
        await apolloClient.query(params).then((res) => {
          if (!res.loading) response = res.data.lastReconocimientos;
        });
      } catch (e) {
        console.log("Error metodo lastReconocimientos", e);
      }
      return new Promise((resolve) => {
        if (response != null) {
          if (response.length == 0) {
            resolve(false);
          } else {
            resolve(response);
            commit("SET_LAST_RECONOCIMIENTO", response);
          }
        } else {
          resolve(false);
        }
      });
    },

    async getLastPostMuro({ state, commit }, data_) {
      let response = null;
      commit("SET_STATE", {
        nameState: "empresa",
        data: data_.id_empresa,
      });

      await exQue(
        GET_PAGES_MURO,
        {
          ...data_,
          plataforma: "1",
          fecha_inicio: "",
          fecha_final: "",
          nombre: "",
          limite: "5",
        },
        true
      ).then(async (data) => {
        commit("SET_STATE", {
          nameState: "lastPostsMuroPages",
          data,
        });
        await exQue(GET_MURO_BY_ID, {
          id_empresa: data_.id_empresa,
          plataforma: "1",
          id_muro: data[0].muros,
        }).then((resp) => {
          response = resp;
          const dataHash = [...state.lastPostsMuro, ...resp].reduce(
            (acc, item) => ({ ...acc, [item.id_muro]: item }),
            {}
          );
          const data = Object.values(dataHash).sort(
            (a, b) => new Date(b.fecha_creacion) - new Date(a.fecha_creacion)
          );

          commit("SET_STATE", {
            nameState: "lastPostsMuro",
            data,
          });
          commit("SET_STATE", {
            nameState: "lastPostsMuroPage",
            data: 1,
          });
        });
      });

      return response;
    },

    async nextPageLastPostMuro({ state, commit }) {
      const list = state.lastPostsMuroPages[state.lastPostsMuroPage];
      if (list === undefined) return;

      await exQue(GET_MURO_BY_ID, {
        id_empresa: state.empresa,
        plataforma: "1",
        id_muro: list.muros,
      }).then((resp) => {
        const dataHash = [...state.lastPostsMuro, ...resp].reduce(
          (acc, item) => ({ ...acc, [item.id_muro]: item }),
          {}
        );
        const data = Object.values(dataHash).sort(
          (a, b) => new Date(b.fecha_creacion) - new Date(a.fecha_creacion)
        );

        commit("SET_STATE", {
          nameState: "lastPostsMuro",
          data,
        });
        commit("SET_STATE", {
          nameState: "lastPostsMuroPage",
          data: state.lastPostsMuroPage + 1,
        });
      });
    },

    async crearNuevoPostMuro({ commit }, data_) {
      let response = null;
      let data = [];
      let params = {
        mutation: CREAR_POST_MURO,
        variables: data_,
      };
      try {
        await apolloClient.mutate(params).then((res) => {
          if (!res.loading) data = res.data.crearMuro;
          response = data;
        });
      } catch (e) {
        console.log("Falla metodo crearNuevoPostMuro: ", e);
      }
      return new Promise((resolve) => {
        if (response != null) {
          resolve(response);
          commit("SET_NEW_POST", response);
        } else {
          resolve(false);
        }
      });
    },

    async updatePostMuro({ commit }, data_) {
      let response = null;
      let params = {
        mutation: EDITA_POST,
        variables: data_,
      };
      try {
        await apolloClient.mutate(params).then((res) => {
          if (!res.loading) response = res.data.editarMuro;
        });
      } catch (e) {
        console.log("Falla metodo updatePostMuro: ", e);
      }
      return new Promise((resolve) => {
        if (response != null) {
          resolve(response);
          commit("SET_UPDATE_POST_MURO", response);
        } else {
          resolve(false);
        }
      });
    },

    async crearComentariosPostMuro({ commit }, data_) {
      let response = null;
      let params = {
        mutation: CREAR_COMENTARIOS_MURO,
        variables: data_,
      };
      try {
        await apolloClient.mutate(params).then((res) => {
          if (!res.loading) response = res.data.enviarComentarioMuro;
        });
      } catch (e) {
        console.log("Falla metodo crearComentariosPostMuro: ", e);
      }
      return new Promise((resolve) => {
        if (response != null) {
          resolve(response);
          commit("SET_COMENTARIO_MURO", response);
        } else {
          resolve(false);
        }
      });
    },

    async updateComentariosPostMuro({ commit }, data_) {
      let response = null;
      let params = {
        mutation: EDITAR_COMENTARIOS_MURO,
        variables: data_,
      };
      try {
        await apolloClient.mutate(params).then((res) => {
          if (!res.loading) response = res.data.editarComentarioMuro;
        });
      } catch (e) {
        console.log("Falla metodo updateComentariosPostMuro: ", e);
      }
      return new Promise((resolve) => {
        if (response != null) {
          resolve(response);
          commit("SET_COMENTARIO_MURO", response);
        } else {
          resolve(false);
        }
      });
    },

    async addLikeComentario({ commit }, data_) {
      let response = null;
      let data = [];
      let params = {
        mutation: DAR_LIKE_COMENTARIO_MURO,
        variables: data_,
      };
      try {
        await apolloClient.mutate(params).then((res) => {
          if (!res.loading) data = res.data.darLikeMuroComentario;
          response = data;
        });
      } catch (e) {
        console.log("Falla metodo addLikeComentario: ", e);
      }
      return new Promise((resolve) => {
        if (response != null) {
          resolve(response);
          commit("SET_COMENTARIO_MURO", response);
        } else {
          resolve(false);
        }
      });
    },

    async delLikeComentario({ commit }, data_) {
      let response = null;
      let data = [];
      let params = {
        mutation: QUITAR_LIKE_COMENTARIOS_MURO,
        variables: data_,
      };
      try {
        await apolloClient.mutate(params).then((res) => {
          if (!res.loading) data = res.data.quitarLikeMuroComentario;
          response = data;
        });
      } catch (e) {
        console.log("Falla metodo delLikeComentario: ", e);
      }
      return new Promise((resolve) => {
        if (response != null) {
          resolve(response);
          commit("DEL_COMENTARIO_MURO", response);
        } else {
          resolve(false);
        }
      });
    },

    async addLikeMuroPost({ commit, dispatch }, payload) {
      Object.assign(payload, {
        id_modulo: "2",
        id_subobjeto: "0",
      });
      const response = await dispatch("LikesModule/darLikeAction", payload, {
        root: true,
      });
      // console.log(response, payload)
      commit("SET_LIKE_MURO_POST", Object.assign(response, payload));
      return response;
    },
    async delLikeMuroPost({ commit, dispatch }, payload) {
      Object.assign(payload, {
        id_modulo: "2",
        id_subobjeto: "0",
      });
      const response = await dispatch("LikesModule/quitarLikeAction", payload, {
        root: true,
      });
      // console.log(response, payload)
      commit("REMOVE_LIKE_MURO_POST", Object.assign(response, payload));
      return response;
    },

    async delPostMuro({ commit }, data_) {
      let response = null;
      let data = [];
      let params = {
        mutation: ELIMINAR_POST,
        variables: data_,
      };
      try {
        await apolloClient.mutate(params).then((res) => {
          if (!res.loading) data = res.data.eliminarMuro;
          response = data;
        });
      } catch (e) {
        console.log("Error de delPostMuro post: ", e);
      }
      return new Promise((resolve) => {
        if (response != null) {
          console.log("DELETE POST ", response);
          if (response.id_muro != 0 || response.id_muro != null) {
            commit("DEL_POST_MURO", response);
          }
          resolve(response);
        } else {
          resolve(false);
        }
      });
    },

    async delComentarioPostMuro({ commit }, data_) {
      let response = null;
      let data = [];
      let params = {
        mutation: ELIMINAR_COMENTARIOS_POST,
        variables: data_,
      };
      try {
        await apolloClient.mutate(params).then((res) => {
          if (!res.loading) data = res.data.eliminarComentarioMuro;
          response = data;
        });
      } catch (e) {
        console.log("Error de delPostMuro post: ", e);
      }
      return new Promise((resolve) => {
        if (response != null) {
          if (response.id_muro != 0 || response.id_muro != null) {
            commit("DEL_COMENTARIO_MURO", response);
          }
          resolve(response);
        } else {
          resolve(false);
        }
      });
    },
    //INSERTAR VISTO GENERAL
    async insertVisto({ commit }, data_) {
      let response = null;
      let data = [];
      let params = {
        mutation: INSERT_VISTO_GENERAL,
        variables: data_,
      };
      try {
        await apolloClient.mutate(params).then((res) => {
          console.log("INSERT VISTO", res.data);
          if (!res.loading) data = res.data;
          response = data;
        });
      } catch (e) {
        console.log("Falla metodo deleteNotificaciones: ", e);
      }
      return new Promise((resolve) => {
        if (response != null) {
          commit("INSERT_VISTO", {
            noticia: data_.id_objeto,
            respuesta: response,
          });
          resolve(response);
        } else {
          resolve(false);
        }
      });
    },
  },
};
